<div class="modal--container">
  <div class="modal-body">
    <div class="modal-title">Update Information Banner</div>
    <form [formGroup]="parentForm()">
      <div class="toggle-row">
        <label
          [for]="displayInformationBanner().key"
          [formGroup]="parentForm()"
        >
          <div class="label-large">
            {{ displayInformationBanner().label }}
            @if (displayInformationBanner().required) {
              <span class="required" aria-required="true"> * </span>
            }
          </div>
          <mat-slide-toggle
            [id]="displayInformationBanner().key"
            [formControlName]="displayInformationBanner().key"
            ngDefaultControl
            color="primary"
          ></mat-slide-toggle>
        </label>
      </div>
      <app-underlined-textarea-field
        [parentForm]="parentForm()"
        [field]="informationBanner()"
        [minLength]="1"
        [maxLength]="150"
        rows="4"
        [showCharacterCounter]="true"
        labelSize="small"
      ></app-underlined-textarea-field>
      <app-underlined-dropdown-form-field
        [parentForm]="parentForm()"
        [field]="informationBannerType()"
      ></app-underlined-dropdown-form-field>
      <div>
        <div class="label-small">Preview</div>
        <div class="preview-container">
          <app-toast
            [toastStyle]="
              InformationBannerTypeEnum[
                parentForm().get('informationBannerType')?.value
              ]?.toLowerCase() || 'positive'
            "
            [icon]="getIconName()"
            [text]="
              parentForm().get('informationBanner')?.value ||
              'Your information banner text will appear here'
            "
          ></app-toast>
        </div>
      </div>
    </form>
    @if (errorMessage()) {
      <div class="error">Error: {{ errorMessage() }}</div>
    }
    @if (successMessage()) {
      <div class="positive">Success: {{ successMessage() }}</div>
    }
    <div class="button--container double">
      <app-button
        buttonStyle="secondary"
        [label]="secondaryButtonText()"
        [buttonId]="secondaryButtonId()"
        (buttonClicked)="buttonEventHandler(secondaryButtonId())"
        [isDisabled]="isProcessing()"
      ></app-button>
      <app-button
        [label]="primaryButtonText()"
        [buttonId]="primaryButtonId()"
        (buttonClicked)="buttonEventHandler(primaryButtonId())"
        [isDisabled]="isProcessing()"
      ></app-button>
    </div>
  </div>
</div>
<div class="modal--backdrop"></div>
